<template>
    <Loading v-if="didLoadedAllForForm === false"></Loading>

    <v-container v-else fluid style="margin: 0">
        <div class="d-flex align-center">
            <h2 class="header_div">
                {{ $t('reservations.restrict_calendar') }}
            </h2>

            <v-spacer/>
            <v-btn @click="goBack(assistantId)" rounded variant="tonal">{{ $t('reservations.close') }}</v-btn>
            <v-btn
                id="save-btn"
                @click="sendNew()"
                :disabled="!valid"
                color="primary"
                class="ml-3"
            >{{ $t('reservations.save') }}
            </v-btn>
        </div>

        <v-form ref="form" v-model="valid">
            <!--Agenda-->
            <v-row class="no_margin">
                <v-col cols="4" class="v_flex_span_date ">
                    <span class="text">1. {{ $t('reservations.restrict_agend') }}</span>
                </v-col>

                <v-col cols="4" class="">
                    <v-radio-group :disabled="returnAssistantRole === 'STUDY'" class="no_margin_no_padding " v-model="radioGroupWho" inline>
                        <v-radio color="#000" :label="$t('reservations.person')" value="person"></v-radio>
                        <v-radio color="#000" :label="$t('reservations.stud_dep_pef')" value="department" class="ml-5"></v-radio>
                    </v-radio-group>
                    <v-select
                            id="restriction-person"
                            v-if="radioGroupWho === 'person'"
                            v-model="personSelect"
                            :items="getAssistantsForDropdown"
                            :hide-details="true"
                            :rules="[v => !!v || 'Item is required']"
                            required
                            variant="solo"
                    ></v-select>
                </v-col>
            </v-row>

            <!--Duvod Restrikce-->
            <v-row class="no_margin top">
                <v-col cols="4" class="">
                    <span class="text">2. {{ $t('reservations.restrict_reason') }}</span>
                </v-col>

                <v-col cols="4" class="">
                    <v-select
                            id="restriction-reason"
                            v-model="restrictionSelect"
                            :items=getReasonsAccordingToAgenda
                            :hide-details="true"
                            :rules="[v => !!v || $t('reservations.item_required')]"
                            :item-title="restrictionText"
                            item-value="id"
                            required
                            variant="solo"
                    ></v-select>
                </v-col>
            </v-row>

            <!--Datum Restrikce-->
            <v-row class="no_margin top">
                <v-col cols="4" class="">
                    <span class="text">3. {{ $t('reservations.restrict_date') }}</span>
                </v-col>

                <!--Čas od-->
                <v-col cols="4" class="">
                    <date-picker
                        :initial-value="date_from"
                        @date-changed="v => date_from = v.format('YYYY-MM-DD')"
                        :rules="dateRules"
                        :min-date="today"
                        :allowed-dates="allowedDates"
                        variant="solo"
                    />

                    <!--                    &lt;!&ndash;Text do&ndash;&gt;-->
                    <!--                    <v-flex row xs1 align-content-center justify-center class="overdrive">-->
                    <!--                        <span class="doSpan"> do </span>-->
                    <!--                    </v-col>-->

                    <!--                    &lt;!&ndash;Čas do&ndash;&gt;-->
                    <!--                    <v-flex xs2 class="margin_left">-->
                    <!--                        <v-menu-->
                    <!--                                v-model="menu_calendar_to"-->
                    <!--                                :close-on-content-click="false"-->
                    <!--                                :nudge-right="40"-->
                    <!--                                transition="scale-transition"-->
                    <!--                                offset-y-->
                    <!--                                min-width="290px">-->
                    <!--                            <template v-slot:activator="{ on }">-->
                    <!--                                <v-text-field-->
                    <!--                                        v-model="computedDateFormattedTo"-->
                    <!--                                        readonly-->
                    <!--                                        v-on="on"-->
                    <!--                                        class="no_margin_no_padding"-->
                    <!--                                        variant="solo"-->
                    <!--                                        aria-required="true"-->
                    <!--                                        :rules="dateRules"-->
                    <!--                                        :hide-details="true"-->
                    <!--                                ></v-text-field>-->
                    <!--                            </template>-->
                    <!--                            <v-date-picker locale="cs"-->
                    <!--                                           v-model="date_to"-->
                    <!--                                           no-title-->
                    <!--                                           :min="today"-->
                    <!--                                           @input="menu_calendar_to = false"></v-date-picker>-->
                    <!--                        </v-menu>-->
                    <!--                    </v-col>-->
                </v-col>
            </v-row>

            <!--Long Term action option-->
            <v-row class="no_margin top">
                <v-col cols="4">
                    <span class="text">4. {{ $t('reservations.restrict_time') }} </span>
                </v-col>

                <v-col cols="8">
                    <v-radio-group class="no_margin_no_padding " v-model="radioGroupTimeRestriction" column>
                        <v-radio color="#000" :label="$t('reservations.whole_day') +`(${getOpenTime} - ${getCloseTime})`" value="all"></v-radio>
                        <v-radio color="#000" :label="$t('reservations.specific_timespan')" value="personal"></v-radio>
                    </v-radio-group>

                    <!--Čas od-->
                    <div
                        v-if="radioGroupTimeRestriction === 'personal'"
                        class="d-flex align-center no_margin_no_padding bottom">
                        <time-picker
                            v-model="time_from"
                            :label="$t('reservations.time_from')"
                            variant="solo"
                            :rules="timeRules"
                            full-width
                            :min-time="getOpenTime"
                            :max-time="time_to || getCloseTime"
                            @update:valid="v => timeFromValid = v"
                        ></time-picker>

                        <!--Text do-->
                        <div class="doSpan2 mx-3">{{ $t('reservations.untill') }}</div>

                        <!--Cas do-->
                        <time-picker
                            v-model="time_to"
                            :label="$t('reservations.time_to')"
                            variant="solo"
                            :rules="timeRules"
                            full-width
                            :min-time="time_from || getOpenTime"
                            :max-time="getCloseTime"
                            @update:valid="v => timeToValid = v"
                        ></time-picker>
                    </div>
                </v-col>
            </v-row>

            <v-row class="no_margin">
                <v-col cols="4" class="">
                    <span class="text">5. {{ $t('reservations.longterm_action') }} </span>
                </v-col>

                <v-col cols="4" class="">
                    <v-select
                            id="restriction-long-term-action"
                            v-model="longTermAction.option"
                            :items="options"
                            :rules="[v => !!v || $t('entities.required')]"
                            required
                            variant="solo"
                            item-value="value"
                            return-object
                            :disabled="radioGroupWho === 'department'"
                    ></v-select>
                </v-col>
            </v-row>

            <v-row class="no_margin" v-if="returnLongTermActionOption() === 'delegate'">
                <v-col cols="4" class="">
                    <span class="text">6. {{ $t('reservations.delegation') }}</span>
                </v-col>

                <v-col cols="4" class="">
                    <v-select
                            id="restriction-long-term-delegate"
                            v-model="longTermAction.delegatedAssistant"
                            :items="getValidAssistant(computedDateFormattedFrom, time_from, time_to)"
                            :rules="[v => !!v || $t('entities.required')]"
                            required
                            variant="solo"
                            item-value="value"
                            return-object
                            v-if="radioGroupWho === 'person'"
                    ></v-select>
                </v-col>
            </v-row>

            <!-- Affected items -->

            <v-row class="no_margin">
                <v-col cols="12">
                    <span class="text">{{returnCorrectNumbering(6)}}. {{ $t('reservations.restrict_meetings') }} ({{numberOfItems}})</span>
                </v-col>

                <v-col cols="12" v-if="numberOfItems !== 0">
                    <v-data-table
                            :headers="headers"
                            :items="dataToDataTable"
                            items-per-page="25"
                            class="elevation-1"
                            :calculate-widths="true"
                            :loading="isLoading"
                            :sort-by="[{key: 'ticketNumber', order: 'asc'}]"
                    >

                        <template v-slot:item.option="{ item }">
                            <v-select
                                    :id="`ticket-${item.ticketNumber}-action`"
                                    v-model="item.option"
                                    :items="options"
                                    :rules="[v => !!v || $t('reservations.item_required')]"
                                    required
                                    :disabled="disableOptionForSomeoneElse(getValidAssistant(item.wantedDay, item.openTime, item.closeTime))"
                                    variant="underlined"
                            >
                            </v-select>
                        </template>

                        <template v-slot:item.delegate="{ item }">
                            <v-select
                                    :id="`ticket-${item.ticketNumber}-delegate`"
                                    v-model="item.assistantId"
                                    :items="getValidAssistant(item.wantedDay, item.openTime, item.closeTime)"
                                    :rules="conditionalRuleForDelegate(item.option)"
                                    required
                                    :disabled="setDisableIfCancel(item.option, item.id, getValidAssistant(item.wantedDay, item.openTime, item.closeTime))"
                                    variant="underlined"
                            >
                            </v-select>
                        </template>
                        <!--                        <template v-slot:item.otherTime="{ item }">-->
                        <!--                            <v-select-->
                        <!--                                    v-model="item.otherTime"-->
                        <!--                                    :items="getTimeRangeForRestriction(time_from, time_to, item.otherTimeOriginal)"-->
                        <!--                                    :rules="conditionalRuleForDelegate(item.option)"-->
                        <!--                                    required-->
                        <!--                                    :disabled="setDisableIfCancel(item.option, item.id)"-->
                        <!--                            >-->
                        <!--                            </v-select>-->
                        <!--                        </template>-->
                    </v-data-table>
                </v-col>

                <v-col cols="12" v-else>
                    <span>{{ $t('reservations.no_restrict_meetings') }}</span>
                </v-col>
            </v-row>

        </v-form>
    </v-container>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import moment from 'moment';
    import { post } from '@/services/api'
    import Loading from "../../../../../components/Loading";
    import DatePicker from "@/components/date-picker/DatePicker.vue";
    import TimePicker from "@/components/time-picker/TimePicker.vue";

    export default {
        components: {TimePicker, DatePicker, Loading},

        name: "NewRestriction",

        data() {
            return {
                radioGroupWho: 'person',
                radioGroupTimeRestriction: 'all',

                personSelect: null,
                restrictionSelect: null,

                date_from: null,
                date_to: null,

                menu_time_from: false,
                menu_time_from2: false,

                menu_time_to: false,
                menu_time_to2: false,

                time_from: null,
                time_to: null,
                timeFromValid: true,
                timeToValid: true,

                all_day_from: null,
                all_day_to: null,

                valid: true,
                form: null,

                numberOfItems: 0,

                dateRules: [
                    v => !!v || this.$t('reservations.date_required'),
                ],

                timeRules: [
                    v => !!v || this.$t('reservations.time_required'),
                ],

                today: moment().format("YYYY-MM-DD"),

                headers: [
                    {title: this.$t('headers.ticket_id'), value: 'ticketNumber', sortable: false, width: "8%"},
                    {title: this.$t('headers.request'), value: 'studyProblems', sortable: false, width: "5%"},
                    {title: this.$t('headers.date'), value: 'wantedDay', sortable: false},
                    {title: this.$t('headers.time'), value: 'time', sortable: false},
                    {title: this.$t('headers.student'), value: 'studentName', sortable: false, width: "15%"},
                    {title: this.$t('headers.options'), value: 'option', sortable: false, width: "13%"},
                    {title: this.$t('headers.delegate'), value: 'delegate', sortable: false, width: "23%"},
                    //  {title: this.$t('headers.sub_time'), value: 'otherTime', sortable: false, width: "13%"},
                ],

                options: [
                    {title: this.$t('reservations.cancel'), value: 'cancel'},
                    {title: this.$t('reservations.delegate'), value: 'delegate'},
                ],

                longTermAction: {
                    option: {title: this.$t('reservations.cancel'), value: 'cancel'},
                    delegatedAssistant: null,
                },

                didCreate: true,

                dataToDataTable: [],

                affected: [],
                oldAffected: [],
                interval: null,
                isLoading: false,
            }
        },

        unmounted() {
            clearInterval(this.interval);
        },

        async created() {
            this.date_from = this.selectedDay
            this.personSelect = this.assistantId

            this.setSelectedDayFromInfobar();

            await Promise.all([
                this.fetchStudyOpenHours(),
                this.fetchClosedHoursReasons(),
                this.fetchAssistants(),
                this.fetchStudyFields(),
                this.fetchStudyProblemsItems(),
                this.fetchStudyProblemsCategories(),
                this.fetchClosedHours(),
            ])

            this.setTimes();

            await this.fetchConcernedReservations();

            this.interval = setInterval(() =>
                    this.fetchConcernedReservations()
            , 2000)
        },

        computed: {
            ...mapGetters('assistant', ['getAssistantsForDropdown', 'getAssistants', 'didLoadedAssistants']),
            ...mapGetters('changedQueues', ['getChangedQueues', 'didLoadedChangedQueues']),
            ...mapGetters('queueItemStatuses', ['getQueueItemStatus', 'didLoadedQueueItemStatuses']),
            ...mapGetters('closedHours', ['getTypeClosedHoursByDate', 'didLoadedClosedHours']),
            ...mapGetters('queueItems', ['getQueueItem', 'didLoadedQueueItems']),
            ...mapGetters('studyProblemsCategories', ['didLoadedStudyProblemsCategories']),
            ...mapGetters('closedHoursReason', ['getClosedHoursReasons', 'didLoadedClosedHoursReasons']),
            ...mapGetters('StudyOpenHours', ['getStudyOpenHour', 'didLoadedStudyOpenHours', 'getStudyOpenHours']),
            ...mapGetters('studyProblemsItems', ['getStudyProblemsItem', 'didLoadedStudyProblemsItems']),
            ...mapGetters('pageStorage', ['getAssistantStorage', 'getSelectedDayStorage', 'getAssistantIdStorage']),
            ...mapGetters('studyFields', ['getStudyField', 'didLoadedStudyFields' ]),

            selectedDay() {
                return this.getSelectedDayStorage
            },

            assistantId() {
                return this.getAssistantIdStorage;
            },

            reasons() {
                return this.getClosedHoursReasons.map(item => ({
                  id: item.id,
                  name: item.reason,
                  type: item.type,
                }))
            },

            canFetchAffectedItems() {
                return (
                    this.didLoadedAllForAffectedItems &&
                    this.radioGroupWho !== null &&
                    this.date_from !== null &&
                    this.date_to !== null &&
                    this.timeFrom !== null &&
                    this.timeFromValid &&
                    this.timeTo !== null &&
                    this.timeToValid &&
                    (this.personSelect !== null || this.radioGroupWho === "department")
                )
            },

            getReasonsAccordingToAgenda() {
                let data = null;

                if (this.radioGroupWho === "person") {
                    data = this.reasons.filter(obj => obj.type === "person");
                }

                if (this.radioGroupWho === "department") {
                    data = this.reasons.filter(obj => obj.type === "department");
                }

                return data;
            },

            returnAssistantRole() {
                return this.getAssistantStorage.role;
            },

            getRightRestrictionTimeFrom() {
                if (this.radioGroupTimeRestriction === "all") {
                    return this.all_day_from;
                } else {
                    return this.time_from
                }
            },

            getRightRestrictionTimeTo() {
                if (this.radioGroupTimeRestriction === "all") {
                    return this.all_day_to;
                } else {
                    return this.time_to;
                }
            },

            getOpenTime() {
                let closedHours = this.getStudyOpenHours;
                let today = new Date(this.date_from);
                //TODO let today = new Date(this.selectedDay);

                return closedHours.find(closedHours => closedHours.dayNumber === (today.getDay()).toString() && closedHours.purpose === "mobile").openTime;
            },

            getCloseTime() {
                let closedHours = this.getStudyOpenHours;
                let today = new Date(this.date_from);
                //TODO let today = new Date(this.selectedDay);

                return closedHours.find(closedHours => closedHours.dayNumber === (today.getDay()).toString() && closedHours.purpose === "mobile").closeTime;
            },

            computedDateFormattedFrom() {
                return this.formatDate(this.date_from);
            },

            computedDateFormattedTo() {
                return this.formatDate(this.date_to);
            },

            didLoadedAllForForm() {
                return this.didLoadedClosedHoursReasons && this.didLoadedStudyOpenHours && this.didLoadedAssistants && this.didLoadedStudyFields && this.didLoadedStudyProblemsItems && this.didLoadedStudyProblemsCategories
                    && this.didLoadedClosedHours;
            },

            didLoadedAllForAffectedItems() {
                return this.didLoadedAllForForm && this.didLoadedQueueItemStatuses && this.didLoadedQueueItems && this.didLoadedChangedQueues;
            },
        },

        methods: {
            ...mapActions('assistant', ['fetchAssistants']),
            ...mapActions('changedQueues', ['fetchChangedQueuesByWantedDay']),
            ...mapActions('queueItemStatuses', ['fetchQueueItemStatusesByWantedDay']),
            ...mapActions('queueItems', ['fetchQueueItemsByWantedDay']),
            ...mapActions('studyProblemsCategories', ['fetchStudyProblemsCategories']),
            ...mapActions('closedHoursReason', ['fetchClosedHoursReasons']),
            ...mapActions('closedHours', ['fetchClosedHours']),
            ...mapActions('StudyOpenHours', ['fetchStudyOpenHours']),
            ...mapActions('studyProblemsItems', ['fetchStudyProblemsItems']),
            ...mapActions('studyFields', ['fetchStudyFields']),

            restrictionText: item => item.name,

            async fetchQueueItemsForSelectedDay() {
                await Promise.all([
                    this.fetchQueueItemsByWantedDay(this.date_from),
                    this.fetchQueueItemStatusesByWantedDay(this.date_from),
                    this.fetchChangedQueuesByWantedDay(this.date_from),
                ])
            },

            getValidAssistant(wantedDay, startTime, endTime) {
                let restrictions = this.getTypeClosedHoursByDate(moment(wantedDay, "DD.MM.YYYY").format("YYYY-MM-DD"))
                let assistants = this.getAssistantsForDropdown.filter(ass => ass.value !== this.personSelect);

                let toDelete = [];

                if (restrictions.length !== 0) {
                    for (let restriction of restrictions) {
                        if (moment(restriction.timeFrom, "HH:mm").isSameOrBefore(moment(startTime, "HH:mm")) && moment(restriction.timeTo, "HH:mm").isSameOrAfter(moment(endTime, "HH:mm"))) {
                            toDelete.push(restriction.assistantId)
                        }
                    }
                }

                return assistants.filter(ass => !toDelete.includes(ass.value))
            },

            returnLongTermActionOption() {
                return this.longTermAction.option.value;
            },

            returnCorrectNumbering(number) {
                if (this.returnLongTermActionOption() === "cancel") {
                    return number;
                } else {
                    return number + 1;
                }
            },

            setTimes() {
                this.time_from = this.getOpenTime;
                this.time_to = this.getCloseTime;
                this.all_day_from = this.getOpenTime;
                this.all_day_to = this.getCloseTime;
            },

            formatDate(date) {
                if (!date) return null;

                const [year, month, day] = date.split('-');
                return `${day}.${month}.${year}`;
            },

            setSelectedDayFromInfobar() {
                this.date_from = this.selectedDay.get("year").toString() + '-'
                    + this.addZeroBefore((this.selectedDay.get("month") + 1).toString()) + '-'
                    + this.setDay(this.selectedDay.get("date"));

                this.date_to = this.selectedDay.get("year").toString() + '-'
                    + this.addZeroBefore((this.selectedDay.get("month") + 1).toString()) + '-'
                    + this.setDay(this.selectedDay.get("date")).toString();
            },

            setDay(day) {
                if (parseInt(day) < 10) {
                    return ('0' + day).toString();
                } else {
                    return (day).toString();
                }
            },

            addZeroBefore(dayMonth) {
                if (dayMonth.length === 1) {
                    dayMonth = '0' + dayMonth;
                }
                return dayMonth
            },

            goBack(assistantId) {
                this.$router.push({name: "CalendarDetail", params: {assistantID: assistantId}});
            },

            async fetchConcernedReservations() {
                if (!this.canFetchAffectedItems) return;
                this.isLoading = true;
                await this.fetchQueueItemsForSelectedDay();
                await post('study_department/assistant/closed_hours/affected/', {
                    'type': this.radioGroupWho,
                    'assistantId': this.personSelect,
                    'dateFrom': this.date_from,
                    'dateTo': this.date_from,
                    // TODO 'dateTo': this.date_to,
                    'timeFrom': this.getRightRestrictionTimeFrom,
                    'timeTo': this.getRightRestrictionTimeTo,
                }).then((response) => {
                    this.affected = response.data.items;
                    this.updateAffectedItems();
                    this.isLoading = false;
                }).catch(e => alert(e.message));
            },

            addNewRestrictionToBackend: function () {
                this.didCreate = false;

                post('study_department/assistant/closed_hours/', {
                    "assistantId": this.personSelect,
                    'dateFrom': this.date_from,
                    'dateTo': this.date_from,
                    //TODO 'dateTo': this.date_to,
                    'timeFrom': this.getRightRestrictionTimeFrom,
                    'timeTo': this.getRightRestrictionTimeTo,
                    'closedHoursReasonId': this.restrictionSelect,
                    'toChange': this.dataToDataTable,
                    'longTermOption': this.longTermAction.option.value,
                    'longTermAssistantId': this.returnDelegatedAssistant(),
                }).then((response) => {
                    if (response !== null) {
                        this.didCreate = true;
                    }
                }).catch(e => alert(e.message));
            },

            returnDelegatedAssistant() {
              if (this.longTermAction.delegatedAssistant !== null) {
                  return this.longTermAction.delegatedAssistant.value;
              }  else {
                  return null;
              }
            },

            sendNew() {
                this.addNewRestrictionToBackend();
                this.goBack(this.assistantId);
            },

            setDisableIfCancel(item, itemId, assistants) {
                if ((item === 'cancel' && this.dataToDataTable.length > 0) || this.radioGroupWho === "department" || assistants.length === 0) {
                    for (var itm of this.dataToDataTable) {
                        if (itm.id === itemId) {
                            itm.assistantId = null;
                            itm.otherTime = itm.otherTimeOriginal;
                        }
                    }
                    return true;
                } else {
                    return false;
                }
            },

            disableOptionForSomeoneElse(assistants) {
                return this.radioGroupWho === 'department' || assistants.length === 0;
            },

            getTimeRangeForRestriction(startTime, endTime, toAdd) {
                let timerange = [toAdd];
                let step = 30; //minutes
                let startHours = parseInt(startTime.substring(0, 2));
                let endHours = parseInt(endTime.substring(0, 2));

                let minDiff = 2;

                for (let hour = startHours; hour < endHours; hour++) {
                    for (let min = 0; min < minDiff; min++) {
                        timerange.push(this.addZeroBefore(hour.toString()) + ":" + this.addZeroBefore((min * step).toString()));
                    }
                }

                return timerange.sort(function (a, b) {
                    return a > b;
                });
            },


            resetTimeFromTo() {
                let realTimeFrom = this.getOpenTime;
                let realTimeTo = this.getCloseTime;

                this.timeFromValid = true
                this.timeToValid = true

                this.time_from = realTimeFrom;
                this.time_to = realTimeTo;
            },

            resetRestrictionSelect() {
                this.restrictionSelect = null;
            },

            resetLongTermAction() {
                this.longTermAction = {
                    option: {title: this.$t('reservations.cancel'), value: 'cancel'},
                    delegatedAssistant: null,
                };
            },

            conditionalRuleForDelegate(item) {
                if (item === 'delegate') {
                    return [v => !!v || this.$t('reservations.item_required')];
                } else {
                    return [];
                }
            },

            setItemsToTable(items, rewrite) {

                // rewrite when created, don't rewrite in interval
                if (rewrite) {
                    this.dataToDataTable = [];
                }

                let queueItems = [];
                let changedQueuesItemStatusIds = [];
                let notChangedQueueItems = [];
                let changedQueues = this.getChangedQueues;

                for (let item of items) {
                    queueItems.push(this.getQueueItem(item));
                }

                for (let itemCq of changedQueues) {
                    changedQueuesItemStatusIds.push(itemCq.queueItemStatusId);
                }

                for (let item of queueItems) {
                    if (!changedQueuesItemStatusIds.includes(item.queueItemStatusId)) {
                        notChangedQueueItems.push(item);
                    }
                }

                for (let queueItem of notChangedQueueItems) {
                    let dataPrototype = {
                        ticketNumber: null,
                        studyProblems: null,
                        wantedDay: null,
                        time: null,
                        studentName: null,
                        option: this.setStateOnAgendaChange(this.radioGroupWho),
                        assistantId: null,
                        otherTime: null,
                        queueItemStatusId: null,
                        queueItemId: null,
                        otherTimeOriginal: null,
                        openTime: null,
                        closeTime: null,
                        id: Math.floor((Math.random() * 100000)),
                    };

                    let queueStatus = this.getQueueItemStatus(queueItem.queueItemStatusId);
                    let studyProblems = "";

                    if (queueItem.studyProblemsItemsIds.length !== 0) {
                        for (let problem of queueItem.studyProblemsItemsIds) {
                            studyProblems += this.getStudyProblemsItem(problem).name + ' ';
                        }
                    } else {
                        studyProblems = this.getStudyField(queueItem.studyFieldId).name;
                    }

                    if (studyProblems.length > 90) {
                        studyProblems = studyProblems.slice(0, 87) + "..."
                    }

                    dataPrototype.ticketNumber = queueStatus.ticketNumber;
                    dataPrototype.studentName = this.returnName(queueItem);
                    dataPrototype.wantedDay = this.formatDate(queueStatus.wantedDay);
                    dataPrototype.time = queueStatus.actualMeetTime + ' - ' + queueStatus.actualMeetEnd;

                    dataPrototype.openTime = queueStatus.actualMeetTime;
                    dataPrototype.closeTime = queueStatus.actualMeetEnd;

                    dataPrototype.otherTime = queueStatus.actualMeetTime;
                    dataPrototype.otherTimeOriginal = queueStatus.actualMeetTime;
                    dataPrototype.queueItemStatusId = queueItem.queueItemStatusId;
                    dataPrototype.queueItemId = queueItem.id;
                    dataPrototype.studyProblems = studyProblems;

                    this.dataToDataTable.push(dataPrototype);
                }
                this.numberOfItems = this.dataToDataTable.length;
            },

            returnName: function (queueItem) {
                if (queueItem.xname === null && queueItem.nameSurnameTitle != null) {
                    return queueItem.nameSurnameTitle;
                } else if (queueItem.nameSurnameTitle === null && queueItem.xname != null) {
                    return '(' + queueItem.xname + ')';
                } else if (queueItem.nameSurnameTitle === "Empty" && queueItem.xname === "Empty") {
                    return this.$t('reservations.anon_student')
                } else {
                    return queueItem.nameSurnameTitle + ' (' + queueItem.xname + ')';
                }
            },

            allowedDates(apiDate) {
                const openHour = this.getStudyOpenHour(moment(apiDate, "YYYY-MM-DD").day().toString());

                return !((openHour.openTime === "" || openHour.openTime === null) && openHour.closeTime === "" || (openHour.closeTime === null));
            },

            setStateOnAgendaChange(state) {
                if (state === "department") {
                    return 'cancel'
                }

                if (state === "person") {
                    return 'delegate'
                }
            },

            compareArrays(arrA, arrB) {

                if (arrA.length !== arrB.length) return false;

                var cA = arrA.slice().sort().join(",");
                var cB = arrB.slice().sort().join(",");

                return cA === cB;
            },

            updateAffectedItems() {
                // nothing has changed
                if (this.compareArrays(this.oldAffected, this.affected)) return;

                // New queueItems added during creating the restriction
                let newItems = this.affected.filter(a => !this.oldAffected.includes(a));

                // All queueItems deleted during creating the restriction
                let removedItemIds = this.oldAffected.filter(a => !this.affected.includes(a));

                // Remove all deleted queueItems from dataTable
                this.dataToDataTable = this.dataToDataTable.filter(a => !removedItemIds.includes(a.queueItemId))

                // Set new queueItems to dataTable
                this.setItemsToTable(newItems, false);

                this.oldAffected = this.affected;
            },

            cancelAllAffectedItems() {
                for (const item of this.dataToDataTable) {
                    item.option = 'cancel'
                }
            },
        },

        watch: {
            radioGroupWho: async function () {
                this.resetLongTermAction();
                this.resetRestrictionSelect();
                await this.fetchConcernedReservations();
                if (this.radioGroupWho === 'department') {
                    this.cancelAllAffectedItems()
                }
            },

            personSelect: async function () {
                await this.fetchConcernedReservations();
            },

            date_from: async function () {
                this.setTimes();
                await this.fetchQueueItemsForSelectedDay();
                await this.fetchConcernedReservations();
            },

            date_to: async function () {
                this.setTimes();
                await this.fetchQueueItemsForSelectedDay();
                await this.fetchConcernedReservations();
            },

            time_from: async function () {
                await this.fetchConcernedReservations();
            },

            time_to: async function () {
                await this.fetchConcernedReservations();
            },

            radioGroupTimeRestriction: async function () {
                if (this.radioGroupTimeRestriction === 'all') {
                    this.resetTimeFromTo();
                }
                await this.fetchConcernedReservations();
            },
        }
    }

</script>

<style scoped>
    .no_margin {
        margin: 0;
    }

    .margin_left {
        margin-left: 0.7rem;
    }

    .header_div {
        width: fit-content;
    }

    .v_flex_span_date {
        width: 25rem;
    }

    .no_margin_no_padding {
        margin: 0;
        padding: 0;
    }

    .text {
        font-size: large;
        color: black !important;
    }

    .v-input__slot {
        margin: 0 !important;
    }

    .top {
        padding-top: 1rem;
    }

    .bottom {
        padding-bottom: 1rem;
    }

    .doSpan {
        font-size: large;
        padding-bottom: 1.2rem;
        padding-left: 0.5rem;
    }

    .doSpan2 {
        font-size: large;
        padding-bottom: 1.2rem;
        padding-left: 0.5rem;
    }
</style>
